import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { clickManagerContext } from '../../util/contextNamespace';

var DropdownItemClickManager = function (_Component) {
  _inherits(DropdownItemClickManager, _Component);

  function DropdownItemClickManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DropdownItemClickManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropdownItemClickManager.__proto__ || _Object$getPrototypeOf(DropdownItemClickManager)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClicked = function (event) {
      _this.props.onItemClicked(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DropdownItemClickManager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, clickManagerContext, {
        itemClicked: this.handleItemClicked
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return DropdownItemClickManager;
}(Component);

DropdownItemClickManager.childContextTypes = _defineProperty({}, clickManagerContext, PropTypes.object);
export default DropdownItemClickManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/components/context/DropdownItemClickManager.js
// module id = 678
// module chunks = 0